var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2782_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0591 15.4854C12.7333 15.659 12.3699 15.7498 12.0008 15.7498C11.6317 15.7498 11.2683 15.659 10.9426 15.4854L5.51075e-05 9.65039V18.7501C-0.00426292 19.1453 0.0703856 19.5374 0.219621 19.9033C0.368856 20.2692 0.589672 20.6016 0.869112 20.8811C1.14855 21.1605 1.48099 21.3813 1.84692 21.5306C2.21284 21.6798 2.60489 21.7545 3.00005 21.7501H21.0001C21.3952 21.7545 21.7873 21.6798 22.1532 21.5306C22.5191 21.3813 22.8516 21.1605 23.131 20.8811C23.4104 20.6016 23.6313 20.2692 23.7805 19.9033C23.9297 19.5374 24.0044 19.1453 24.0001 18.7501V9.65039L13.0591 15.4854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 2.25018H3.00005C2.60489 2.24586 2.21284 2.32051 1.84692 2.46974C1.48099 2.61898 1.14855 2.83979 0.869112 3.11923C0.589672 3.39867 0.368856 3.73111 0.219621 4.09704C0.0703856 4.46297 -0.00426292 4.85501 5.51075e-05 5.25018V7.50018C-6.27348e-05 7.63616 0.0367927 7.76962 0.106678 7.88627C0.176564 8.00292 0.276849 8.09838 0.396805 8.16243L11.6468 14.1624C11.7556 14.22 11.8769 14.2501 12.0001 14.2501C12.1232 14.2501 12.2445 14.22 12.3533 14.1624L23.6033 8.16243C23.7233 8.09838 23.8235 8.00292 23.8934 7.88627C23.9633 7.76962 24.0002 7.63616 24.0001 7.50018V5.25018C24.0044 4.85501 23.9297 4.46297 23.7805 4.09704C23.6313 3.73111 23.4104 3.39867 23.131 3.11923C22.8516 2.83979 22.5191 2.61898 22.1532 2.46974C21.7873 2.32051 21.3952 2.24586 21.0001 2.25018Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2782_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4a1063a287ae7eed15dada7fa2a7e3b5.svg";
export { ForwardRef as ReactComponent };